import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Image from '@base/FutureImage';
import deviceHelper from '@utils/deviceHelper';

const Container = styled.div`
  width: 100%;
  margin-top: ${Spacings.SPACING_16B};
  ${mediaQuery.uptoMobile} {
    padding: 0 ${Spacings.SPACING_4B};
    margin-top: ${Spacings.SPACING_8B};
  }
`;

const StyImage = styled(Image)`
  ${mediaQuery.uptoMobile} {
    max-width: 100%;
    height: auto;
  }
`;

const bannerSizeConfig = {
  web: {
    width: 1136,
    height: 200
  },
  mweb: {
    width: 600,
    height: 142
  }
};

const Banner = ({ bannerInfo }) => {
  const isMobile = deviceHelper.isMobileDevice();
  const { web, mweb } = bannerInfo || {};

  return (
    <Container>
      <StyImage
        src={!isMobile ? web : mweb}
        alt="banner"
        width={
          !isMobile ? bannerSizeConfig.web.width : bannerSizeConfig.mweb.width
        }
        height={
          !isMobile ? bannerSizeConfig.web.height : bannerSizeConfig.mweb.height
        }
      />
    </Container>
  );
};

export default Banner;
